import React, { useState } from 'react';
import { X, UserPlus, Save, Loader } from 'lucide-react';
import { config } from '../../config';

const LeadCaptureModal = ({ onClose }) => {
    const [submitting, setSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        company: '',
        source: 'Landing Page',
        notes: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const referredBy = localStorage.getItem('REFERRED_BY');
            const response = await fetch(`${config.API_BASE_URL}/webhook/hq-capture-lead`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ...formData,
                    Source: referredBy ? 'Referral' : formData.source,
                    Referred_By_Email: referredBy || '',
                    Timestamp: new Date().toISOString()
                })
            });
            if (!response.ok) {throw new Error('Failed to capture lead');}
            alert('Lead captured successfully!');
            onClose();
        } catch (error) {
            console.error(error);
            alert('Error: ' + error.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full overflow-hidden animate-in zoom-in-95 duration-200">
                <div className="bg-slate-50 border-b border-slate-100 p-6 flex justify-between items-center">
                    <div className="flex items-center gap-3">
                        <div className="bg-purple-100 p-2 rounded-xl text-purple-600">
                            <UserPlus size={20} />
                        </div>
                        <h2 className="text-xl font-black text-slate-800">Capture Lead</h2>
                    </div>
                    <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full text-slate-400">
                        <X size={20} />
                    </button>
                </div>
                <div className="p-6">
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="block text-xs font-bold text-slate-500 uppercase mb-1">First Name</label>
                                <input required id="firstName" value={formData.firstName} onChange={handleChange} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl" />
                            </div>
                            <div>
                                <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Last Name</label>
                                <input required id="lastName" value={formData.lastName} onChange={handleChange} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl" />
                            </div>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Email</label>
                            <input required type="email" id="email" value={formData.email} onChange={handleChange} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl" />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Company</label>
                            <input id="company" value={formData.company} onChange={handleChange} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl" />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Source</label>
                            <select id="source" value={formData.source} onChange={handleChange} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl">
                                <option>Portal</option>
                                <option>Referral</option>
                                <option>Ads</option>
                                <option>Manual</option>
                            </select>
                        </div>
                        <button type="submit" disabled={submitting} className="w-full bg-purple-600 text-white py-4 rounded-xl font-bold uppercase tracking-widest flex items-center justify-center gap-2">
                            {submitting ? <Loader className="animate-spin" /> : 'Save Lead'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LeadCaptureModal;
